module.exports = __webpack_public_path__ + "images/120_160.jpg";